// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  deckItemId: __t.u64().primaryKey().name("deck_item_id"),
  owner: __t.identity(),
  shipId: __t.u64().name("ship_id"),
  propKey: __t.string().name("prop_key"),
  x: __t.f32(),
  z: __t.f32(),
  yaw: __t.f32(),
  placedAt: __t.timestamp().name("placed_at"),
});
